export default "__VITE_ASSET__DarPuu$___"